import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-ion-common-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
})
export class LabelComponent {

  @Input() labelDescription: string;
  @Input() label: string;
  @Input() labelStyle: string;
  @Input() labelAria: string;
  @Input() ariaLevel = 2;
  @Input() labelLink?: string;
  @Input() ariaLabelLink?: string;
  @Input() idLink?: string;
  @Input() idTitle?: string;
  @Output() sendClickLink = new EventEmitter();

  focusBtn($event: any) {
    $event.stopPropagation();
  }

}
